import { Actions } from "./companyConstants";
import produce from "immer";

const initialState = {
  data: null,
  loading: false,
  uploading: false,
  operationResult: null,

  // Subscriptions
  subscriptions: {
    data: [],
    subscriptionTypes: [],
    pricingModels: [],
    loading: false,
  },

  // Pricing Schedules
  pricingSchedules: {
    data: [],
    loading: false,
  },
};

export const reducer = (state = initialState, action) => {
  return produce(state, (draft) => {
    switch (action.type) {
      case Actions.READ_COMPANY:
        draft.loading = true;
        draft.data = null;
        return draft;

      case Actions.READ_COMPANY_SUCCEEDED:
        draft.loading = false;
        draft.data = action.payload.Data;
        draft.operationResult =
          action.payload.Operation.Outcome !== "Success"
            ? action.payload.Operation
            : null;
        return draft;

      case Actions.UPDATE_COMPANY:
        draft.loading = true;
        draft.operationResult = null;
        return draft;

      case Actions.UPDATE_COMPANY_SUCCEEDED:
        if (action.payload.Operation.Outcome === "Success") {
          draft.data = action.payload.Data;
        }
        draft.operationResult = action.payload.Operation;
        draft.loading = false;
        return draft;

      case Actions.UPLOAD_CONTRACT:
        draft.uploading = true;
        draft.operationResult = null;
        return draft;

      case Actions.UPLOAD_CONTRACT_SUCCEEDED:
        draft.uploading = false;
        if (action.payload.Operation?.Outcome === "Success") {
          draft.data = action.payload.Data;
        }
        draft.operationResult = action.payload.Operation;
        return draft;

      // ── Subscriptions ──
      case Actions.LIST_SUBSCRIPTIONS:
        draft.subscriptions.loading = true;
        return draft;

      case Actions.LIST_SUBSCRIPTIONS_SUCCEEDED:
        draft.subscriptions.loading = false;
        if (action.payload.Operation?.Outcome === "Success") {
          draft.subscriptions.data = action.payload.Data?.Subscriptions || [];
          draft.subscriptions.subscriptionTypes = action.payload.Data?.SubscriptionTypes || [];
          draft.subscriptions.pricingModels = action.payload.Data?.PricingModels || [];
        } else {
          draft.operationResult = action.payload.Operation;
        }
        return draft;

      case Actions.UPSERT_SUBSCRIPTION:
      case Actions.DELETE_SUBSCRIPTION:
        draft.subscriptions.loading = true;
        draft.operationResult = null;
        return draft;

      case Actions.UPSERT_SUBSCRIPTION_SUCCEEDED:
      case Actions.DELETE_SUBSCRIPTION_SUCCEEDED:
        draft.subscriptions.loading = false;
        if (action.payload.Operation?.Outcome === "Success") {
          draft.subscriptions.data = action.payload.Data?.Subscriptions || [];
          draft.subscriptions.subscriptionTypes = action.payload.Data?.SubscriptionTypes || [];
          draft.subscriptions.pricingModels = action.payload.Data?.PricingModels || [];
        }
        draft.operationResult = action.payload.Operation;
        return draft;

      // ── Pricing Schedules ──
      case Actions.LIST_PRICING_SCHEDULES:
        draft.pricingSchedules.loading = true;
        return draft;

      case Actions.LIST_PRICING_SCHEDULES_SUCCEEDED:
        draft.pricingSchedules.loading = false;
        if (action.payload?.Operation?.Outcome === "Success") {
          draft.pricingSchedules.data = action.payload.Data?.PricingSchedules || [];
        } else {
          draft.operationResult = action.payload?.Operation;
        }
        return draft;

      case Actions.CREATE_PRICING_SCHEDULE:
      case Actions.UPDATE_PRICING_SCHEDULE:
      case Actions.DELETE_PRICING_SCHEDULE:
        draft.pricingSchedules.loading = true;
        draft.operationResult = null;
        return draft;

      case Actions.CREATE_PRICING_SCHEDULE_SUCCEEDED:
      case Actions.UPDATE_PRICING_SCHEDULE_SUCCEEDED:
      case Actions.DELETE_PRICING_SCHEDULE_SUCCEEDED:
        draft.pricingSchedules.loading = false;
        if (action.payload?.Operation?.Outcome === "Success") {
          draft.pricingSchedules.data = action.payload.Data?.PricingSchedules || [];
        }
        draft.operationResult = action.payload?.Operation;
        return draft;

      case Actions.CLEAR_OPERATION_RESULT:
        draft.operationResult = null;
        return draft;

      default:
        return state;
    }
  });
};
